import { DEPLOYMENT_KEYS } from 'utils/constants'
import { clampStudyDay } from '../constants'
import { getVisitStudyDayFromTemplate } from '../engine/visitAnchorStudyDay'

/** Resolve visit anchor ids from legacy visit_id or multi-visit visit_ids (GOLD-12250). */
export const getChainDeployVisitIds = chainDeploymentInfo => {
  if (!chainDeploymentInfo) return []
  if (Array.isArray(chainDeploymentInfo.visit_ids) && chainDeploymentInfo.visit_ids.length > 0) {
    return chainDeploymentInfo.visit_ids.filter(id => id != null && id !== '')
  }
  if (chainDeploymentInfo.visit_id != null && chainDeploymentInfo.visit_id !== '') {
    return [chainDeploymentInfo.visit_id]
  }
  return []
}

/** Project study day for visit-triggered deploy: anchor visit day + deploy.days_offset. */
export const getVisitChainedStudyDay = (schedule, visits = [], selectedArmVisitIds = null, context = {}) => {
  const chainDeployment = schedule?.chain_deployment_info
  const visitIds = getChainDeployVisitIds(chainDeployment)
  if (!visitIds.length) return null

  const isVisitChained =
    chainDeployment &&
    (DEPLOYMENT_KEYS.chainDeployByVisit in chainDeployment || visitIds.length > 0)
  if (!isVisitChained) return null

  const candidateIds =
    selectedArmVisitIds != null
      ? visitIds.filter(id => selectedArmVisitIds.has(String(id)))
      : visitIds

  if (selectedArmVisitIds != null && candidateIds.length === 0) {
    return null
  }

  const idsToTry = candidateIds.length ? candidateIds : visitIds
  const daysOffsetRaw = schedule?.deploy?.days_offset
  const daysOffsetNum =
    daysOffsetRaw !== undefined && daysOffsetRaw !== null && daysOffsetRaw !== ''
      ? Number(daysOffsetRaw)
      : 0
  const offset = Number.isFinite(daysOffsetNum) ? daysOffsetNum : 0

  const participantVisits = context.participantVisits
  const useParticipantVisits = context.projectionMode === 'participant' && participantVisits?.length

  for (const visitId of idsToTry) {
    let visitStudyDayNum = null
    if (useParticipantVisits) {
      visitStudyDayNum = getVisitStudyDayFromTemplate(
        { visits: [{ visit_id: visitId }], point: 'target' },
        visits,
        selectedArmVisitIds,
        participantVisits,
        context,
      )
    } else {
      const visit = visits.find(v => v.id != null && String(v.id) === String(visitId))
      visitStudyDayNum = visit ? getVisitStudyDayFromTemplate({ visits: [{ visit_id: visitId }] }, visits) : null
    }
    if (visitStudyDayNum == null) continue
    const actualOccurrenceDay = visitStudyDayNum + offset
    return clampStudyDay(actualOccurrenceDay) ?? actualOccurrenceDay
  }

  return null
}
